import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
export const SPINNER_ELEMENT_TAG = "svg";
export const Spinner = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("svg", {
        "aria-label": "Loading",
        "aria-live": "polite",
        className: classNames("block origin-center animate-spinnerRotate motion-reduce:animate-none", className),
        height: 24,
        ref: forwardedRef,
        role: "alert",
        width: 24,
        viewBox: "0 0 66 66",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "LOADING_SPINNER",
        ...restOfProps,
        children: /*#__PURE__*/ _jsx("circle", {
            className: "origin-center animate-spinnerDash motion-reduce:animate-none",
            cx: 33,
            cy: 33,
            fill: "none",
            r: 29,
            stroke: "currentColor",
            strokeDasharray: 187,
            strokeDashoffset: 0,
            strokeWidth: 8,
            strokeLinecap: "round"
        })
    });
});
Spinner.displayName = "Spinner";
